import { PanelBody, SelectControl, ToggleControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';

const LAYOUT_OPTIONS = [
	{ label: __( 'Vertical', 'brandy-blocks' ), value: 'vertical' },
	{ label: __( 'Horizontal', 'brandy-blocks' ), value: 'horizontal' },
	{ label: __( 'Alternating', 'brandy-blocks' ), value: 'alternating' },
];

const CONNECTOR_OPTIONS = [
	{ label: __( 'Solid', 'brandy-blocks' ), value: 'solid' },
	{ label: __( 'Dashed', 'brandy-blocks' ), value: 'dashed' },
	{ label: __( 'Dotted', 'brandy-blocks' ), value: 'dotted' },
];

export default function TimelineSettings( { attributes, setAttributes } ) {
	return (
		<PanelBody title={ __( 'Timeline Settings', 'brandy-blocks' ) }>
			<SelectControl
				__nextHasNoMarginBottom
				__next40pxDefaultSize
				label={ __( 'Layout', 'brandy-blocks' ) }
				value={ attributes.layout }
				options={ LAYOUT_OPTIONS }
				onChange={ ( v ) => setAttributes( { layout: v } ) }
			/>
			<SelectControl
				__nextHasNoMarginBottom
				__next40pxDefaultSize
				label={ __( 'Connector style', 'brandy-blocks' ) }
				value={ attributes.connectorStyle }
				options={ CONNECTOR_OPTIONS }
				onChange={ ( v ) => setAttributes( { connectorStyle: v } ) }
			/>
			<ToggleControl
				__nextHasNoMarginBottom
				label={ __( 'Animate on scroll', 'brandy-blocks' ) }
				checked={ attributes.animate }
				onChange={ ( v ) => setAttributes( { animate: v } ) }
			/>
		</PanelBody>
	);
}
